export default __webpack_public_path__ + "static/media/seawars.fbec3c6f.jpg";